import { Button } from '@repo/ui/components/ui/button'
import { Input } from '@repo/ui/components/ui/input'
import { useState } from 'react'
import { toast } from 'sonner'
import { authClient } from '@/lib/auth-client'
import { trpc } from '@/lib/trpc'

interface DataTabProps {
  onAccountDeleted?: () => void
}

export function DataTab({ onAccountDeleted }: DataTabProps) {
  const [confirmText, setConfirmText] = useState('')
  const deleteAccount = trpc.user.deleteAccount.useMutation()

  const handleDelete = async () => {
    if (confirmText !== 'DELETE') {
      toast.error('Type DELETE to confirm account deletion.')
      return
    }

    try {
      await deleteAccount.mutateAsync({ confirmation: 'DELETE' })
      await authClient.signOut()
      toast.success('Account deleted successfully.')
      onAccountDeleted?.()
    } catch (error) {
      toast.error((error as Error).message || 'Failed to delete account')
    }
  }

  return (
    <div className="space-y-4">
      <div className="rounded-[4px] border border-border/70 bg-card">
        <div className="space-y-3 px-5 py-4">
          <div>
            <div className="text-sm font-medium">Delete Account</div>
            <p className="text-sm text-muted-foreground">
              Permanently delete your account and associated data.
            </p>
          </div>
          <p className="text-xs text-muted-foreground">
            This action is irreversible. Type <code>DELETE</code> to confirm.
          </p>
          <div className="flex flex-wrap items-center gap-2">
            <Input
              value={confirmText}
              onChange={(event) => setConfirmText(event.target.value)}
              className="h-9 w-40 border-border/60 bg-white"
              placeholder="Type DELETE"
            />
            <Button
              size="sm"
              variant="destructive"
              className="cursor-pointer"
              onClick={handleDelete}
              disabled={deleteAccount.isPending}
            >
              {deleteAccount.isPending ? 'Deleting...' : 'Delete'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
